<template>
  <div class="candidate-item" v-loading="loading">
    <Checkbox
      v-if="showSelection"
      class="candidate-item__checkbox"
      :value="Number(selected)"
      @change="
        val => {
          selected = Boolean(val);
        }
      "
    />
    <div class="candidate-item__wrapper" @click="click">
      <Avatar
        class="candidate-item__avatar"
        :size="iconSize"
        :url="`/index.php?entryPoint=download&id=${candidate.id}_photo&type=HRPAC_CANDIDATES`"
      />
      <a
        :href="`/index.php?module=HRPAC_CANDIDATES&action=DetailView&record=${candidate.id}`"
        class="candidate-item__text"
        >{{ candidate.name || '[нет имени]' }}</a
      >
    </div>
    <Button
      v-if="allowRemove"
      class="candidate-item__delete"
      hasLeftIcon
      iconName="delete"
      iconColor="#CDD4DA"
      buttonText=""
      buttonColor="transparent"
      @click="$emit('remove-candidate', candidate)"
    />
  </div>
</template>

<script>
import { store } from '@/store';
import Avatar from 'Elements/Avatar/Avatar';
import Button from 'Elements/Button/Button';
import Checkbox from 'Elements/Checkbox/CustomCheckbox';

export default {
  props: {
    candidate: Object,
    allowRemove: Boolean,
    iconSize: {
      type: Number,
      default: 48
    },
    loading: Boolean
  },
  computed: {
    showSelection() {
      return store.state.massAction.showSelection;
    },
    selected: {
      get() {
        return store.state.massAction.selectedCandidates.includes(
          this.candidate.id
        );
      },
      set(value) {
        const selected = value
          ? [this.candidate.id]
          : store.state.massAction.selectedCandidates.filter(
              id => id !== this.candidate.id
            );

        store.commit('massAction/selectCandidate', {
          arr: selected,
          replace: !value
        });
      }
    }
  },
  methods: {
    click() {
      location.href = `/index.php?module=HRPAC_CANDIDATES&action=DetailView&record=${this.candidate.id}`;
    }
  },
  components: {
    Avatar,
    Button,
    Checkbox
  }
};
</script>

<style lang="scss" scoped>
.candidate-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  cursor: pointer;

  &__checkbox {
    margin-right: 14px;
  }

  &__wrapper {
    display: flex;
  }

  &__avatar {
    align-self: center;
    -ms-grid-row-align: center;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    color: $black-190;
    margin-left: 12px;
    align-self: center;
    -ms-grid-row-align: center;
  }

  &__delete {
    margin: 0;
    display: none;

    &::v-deep .button-content {
      margin: 0;
    }

    &::v-deep * {
      pointer-events: none;
    }
  }

  &:hover {
    background: $blue-10;
    border-radius: 8px;

    .candidate-item__delete {
      display: inline;
    }
  }
}
</style>
